import { addNotify } from "features/notify";
import { shortLanguages } from "services/locale";

const actionTypes = {
  GET_NOTIFICATIONS: 'notifications/GET_NOTIFICATIONS',
  GET_NEW_NOTIFICATIONS_COUNT: 'notifications/GET_NEW_NOTIFICATIONS_COUNT',
  SET_NOTIFICATION_CLOSED: 'notifications/SET_NOTIFICATION_CLOSED',
  CHANGE_VISIBILITY_OF_NOTIFICATIONS: 'notifications/CHANGE_VISIBILITY_OF_NOTIFICATIONS',
  ACTION_PROCESSING: 'notifications/ACTION_PROCESSING',
};

const actionProcessing = (payload) => ({ type: actionTypes.ACTION_PROCESSING, payload });

const changeVisibilityOfNotifications = () => async (dispatch, getState, extra) => {
  dispatch({ type: actionTypes.CHANGE_VISIBILITY_OF_NOTIFICATIONS })
};

const getNotifications = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { locale } = getState().locale;
  const state = getState();
  const response = await api.notifications.getNotifications(shortLanguages[state.locale.lang]);
  const errorMessage = locale.hasOwnProperty(response.codeStatus) ? locale[response.codeStatus] : locale.defaultMessage;
  if (response.success) {
    dispatch({ type: actionTypes.GET_NOTIFICATIONS, payload: response.data || [] });
  } else {
    dispatch(addNotify(errorMessage, 'error'));
  }
};

const getNewNotificationsCount = () => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { locale } = getState().locale;
  const response = await api.notifications.getNotificationsCount();
  const errorMessage = locale.hasOwnProperty(response.codeStatus) ? locale[response.codeStatus] : locale.defaultMessage;
  if (response.success) {
    dispatch({ type: actionTypes.GET_NEW_NOTIFICATIONS_COUNT, payload: response.data });
    dispatch(getNotifications());
  } else {
    dispatch(addNotify(errorMessage, 'error'));
  }
};

const setNotificationRead = (seenIds) => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { locale } = getState().locale;
  const response = await api.notifications.setNotificationRead(seenIds);

  const errorMessage = locale.hasOwnProperty(response.codeStatus) ? locale[response.codeStatus] : locale.defaultMessage;
  if (response.success) {
    dispatch(getNotifications())
  } else {
    dispatch(addNotify(errorMessage, 'error'));
  }
};

const setNotificationClosed = (id) => async (dispatch, getState, extra) => {
  const { api } = extra;
  const { locale } = getState().locale;
  dispatch(actionProcessing(true));
  const response = await api.notifications.setNotificationClosed(id);

  const errorMessage = locale.hasOwnProperty(response.codeStatus) ? locale[response.codeStatus] : locale.defaultMessage;
  if (response.success) {
    dispatch({ type: actionTypes.SET_NOTIFICATION_CLOSED, payload: id });
  } else {
    dispatch(addNotify(errorMessage, 'error'));
  }
  dispatch(actionProcessing(false));
};

export {
  actionTypes,
  getNewNotificationsCount,
  setNotificationClosed,
  setNotificationRead,
  getNotifications,
  changeVisibilityOfNotifications,
};
